import { useState } from "react";
import type { ShapeSize } from "./data-table.js";
import { Input } from "../../components/input.js";
import { Button } from "../../components/button.js";

type Props = {
  user: ShapeSize;
  onCancel: () => void;
  onSave: () => void;
};

export const EditShapeSizeForm = ({ user, onCancel, onSave }: Props) => {
  const [form, setForm] = useState(user);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    const res = await fetch(`http://localhost:5000/api/users/${form.id}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(form),
    });

    const result = await res.json();
    if (result.success) {
      alert("Shape Size updated");
      onSave();
    } else {
      alert(result.message || "Failed to update user");
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="space-y-4 p-4 border mt-4 bg-white rounded-md shadow"
    >
      <Input
        name="name"
        value={form.name}
        onChange={handleChange}
        placeholder="Name"
      />
      <Input
        name="status"
        value={form.status}
        onChange={handleChange}
        placeholder="Status (Enabled/Disabled)"
      />

      <div className="flex gap-3">
        <Button type="submit">Update</Button>
        <Button type="button" variant="outline" onClick={onCancel}>
          Cancel
        </Button>
      </div>
    </form>
  );
};
